import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import PropertyCard from 'components/PropertyCard';
import { useDataLayer } from 'hooks/useDataLayer';
import { useTrackSplitEvent } from 'hooks/useTrackSplitEvent';
import { registerInteraction } from 'lib/analytics/recommendations';
import { useSelector } from 'react-redux';
import { getPropertyPageRecommendationsTreatment } from 'store/recommendedProperty/recommendedPropertySelectors';
import { usePersonalisation } from 'hooks/usePersonalisation';

const Property = ({ id: propertyId, index, ...rest }) => {
  const { emitInteractionEvent } = useDataLayer();
  const trackSplitEvent = useTrackSplitEvent();
  const treatment = useSelector(getPropertyPageRecommendationsTreatment);
  const personalisation = usePersonalisation();

  const handlePropertyLinkOnClick = useCallback(() => {
    const cardNumber = index + 1;
    const customAttributes = { user_event_value: propertyId };
    emitInteractionEvent({ type: 'Recommended Properties', value: `Card ${cardNumber} Selected`, customAttributes });

    registerInteraction({
      propertyId,
      treatment,
      placement: 'property_page',
    });

    trackSplitEvent({
      name: 'recommended_property_click',
      value: cardNumber,
    });

    personalisation.trackRecommendationClick(propertyId);
  }, [personalisation, emitInteractionEvent, index, propertyId, treatment, trackSplitEvent]);

  return (
    <PropertyCard
      {...rest}
      id={propertyId}
      featuredOfferId={undefined}
      inline
      onClick={handlePropertyLinkOnClick}
      mr={[4, 0, 4]}
      my={[2, 2, 0]}
      width={[1, 1, 0.32]}
    />
  );
};

Property.propTypes = {
  ...PropertyCard.propTypes,
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

export default Property;
